import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import EcommerceOrderActions from '../Redux/EcommerceOrderRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getEcommerceOrder (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getEcommerceOrder, token, action.filter)
      if (!res.ok) {
        yield put(EcommerceOrderActions.getEcommerceOrderFailure('ERR_MSG_GET_ECOMMERCE_ORDER'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(EcommerceOrderActions.getEcommerceOrderSuccess(DATA_WITH_PAGE))
        } else {
          yield put(EcommerceOrderActions.getEcommerceOrderFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(EcommerceOrderActions.orderFailure())
  }
}

export function * getEcommerceOrderShipping (api, action) {
  yield baseFetchToken(
    api.getEcommerceOrderShipping,
    action.data,
    getToken,
    EcommerceOrderActions.getEcommerceOrderShippingSuccess,
    EcommerceOrderActions.getEcommerceOrderShippingFailure
  )
}

export function * postEcommerceOrderShipping (api, action) {
  yield baseFetchToken(
    api.postEcommerceOrderShipping,
    action.data,
    getToken,
    EcommerceOrderActions.postEcommerceOrderShippingSuccess,
    EcommerceOrderActions.postEcommerceOrderShippingFailure
  )
}

export function * putEcommerceOrderShipping (api, action) {
  yield baseFetchToken(
    api.putEcommerceOrderShipping,
    action.data,
    getToken,
    EcommerceOrderActions.putEcommerceOrderShippingSuccess,
    EcommerceOrderActions.putEcommerceOrderShippingFailure
  )
}

export function * deleteEcommerceOrderShipping (api, action) {
  yield baseFetchToken(
    api.deleteEcommerceOrderShipping,
    action.data,
    getToken,
    EcommerceOrderActions.deleteEcommerceOrderShippingSuccess,
    EcommerceOrderActions.deleteEcommerceOrderShippingFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/EcommerceOrderSagas.js